import React from 'react'
import { IconButtonProps } from './IconButton.types'
import { StyledIconButton } from './IconButton.styles'

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ size = 'medium', variant = 'default', children, ...props }, ref) => {
    return (
      <StyledIconButton ref={ref} $size={size} $variant={variant} {...props}>
        {children}
      </StyledIconButton>
    )
  }
)

IconButton.displayName = 'IconButton'
